/**
 * Created by fworld on 2019/7/24.
 */

import i18n from '@/i18n/i18n'
export default {
  grid: {
    left: '0',
    right: '0',
    top: '0',
    bottom: '3%',
    containLabel: true
  },
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  },
  color: ['#5AD8A6', '#5B8FF9', '#F6BD16', '#E8684A'],
  series:
    {
      name: i18n.t('ding_dan_fen_bu'),
      type: 'pie',
      // radius: ['45%', '70%'],
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: true,
          fontSize: '12'
        },
        emphasis: {
          show: true,
          fontSize: '12'
        }
      },
      labelLine: {
        normal: {
          show: true
        }
      },
      data: [
        {value: 0, name: i18n.t('zhi_fu_ding_dan')},
        {value: 0, name: i18n.t('fei_zhi_fu_ding_dan')},
      ],
      itemStyle: {
        emphasis: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }

}
